<template>
  <div>
    <component
      :is="component"
      v-for="(component, key) in MODALS_COMPONENTS_MAP"
      :key="key"
      :ref="key"
      :payload="modal.payload"
      @close="freeModal"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import SettingsModal from "./settings-modal/SettingsModal.vue";
import {MODALS} from "../constants";
import {MUTATIONS} from "../../../../store/file-browser";
import DeleteSelectedItemModal from "./DeleteSelectedItemModal.vue";
import {isArray} from "lodash";
import ShareModal from "./ShareModal.vue";
import UploadModal from "./UploadModal.vue";
import FileExistsModal from "./FileExistsModal.vue";
import {createModal} from "./action-creater";
import DeleteModal from "./DeleteModal.vue";
import RenameModal from "./RenameModal.vue";
import CustomizeFolderModal from "./CustomizeFolderModal.vue";
import BriefFolderRenameModal from "./BriefFolderRenameModal.vue";
import CreateLinkModal from './CreateLinkModal.vue';
import CompressLoaderModal from "./CompressLoaderModal.vue";
import ConvertModal from "./ConvertModal.vue";
import ResizeModal from "./ResizeModal.vue";
import CropModal from "./CropModal.vue";
import RemoveBackgroundModal from "./RemoveBackgroundModal.vue";
import PreviewFileModal from "./PreviewFileModal.vue";
import UploadToTargetModal from "./UploadToTargetModal.vue";
import TagsEditorModal from "./TagsEditorModal.vue";
import PreviewImageModal from "./PreviewImageModal.vue";
import FileInfoModal from "./FileInfoModal.vue";
import UploadProductFilesModal from "./UploadProductFilesModal.vue";
import FolderSettingsModal from "./FolderSettingsModal.vue";
import MergePptxModal from "./MergePPTXModal.vue";
import ImportFromImage from "@frontend/components/modules/file-browser/modals/ImportFromImage.vue";
import ImportSpreadsheetModal from "@frontend/components/modules/file-browser/modals/ImportSpreadsheetModal.vue";
import PublishToPlatformModal from "./PublishToPlatformModal.vue";
import ShareProofModal from "./ShareProofModal.vue";
import ShareProofVideoModal from "./ShareProofVideoModal.vue";


const { mapGetters, mapMutations } = createNamespacedHelpers('fileBrowser')

const MODALS_COMPONENTS_MAP = {
  [MODALS.SETTINGS]: SettingsModal,
  [MODALS.DELETE_SELECTED]: DeleteSelectedItemModal,
  [MODALS.SHARE]: ShareModal,
  [MODALS.UPLOAD]: UploadModal,
  [MODALS.FILE_EXISTS]: FileExistsModal,
  [MODALS.DELETE_ITEM]: DeleteModal,
  [MODALS.RENAME]: RenameModal,
  [MODALS.CUSTOMIZE_FOLDER]: CustomizeFolderModal,
  [MODALS.BRIEF_FOLDER_RENAME]: BriefFolderRenameModal,
  [MODALS.CREATE_LINK]: CreateLinkModal,
  [MODALS.COMPRESS_LOADER]: CompressLoaderModal,
  [MODALS.CONVERT]: ConvertModal,
  [MODALS.RESIZE]: ResizeModal,
  [MODALS.CROP]: CropModal,
  [MODALS.REMOVE_BACKGROUND]: RemoveBackgroundModal,
  [MODALS.PREVIEW_FILE]: PreviewFileModal,
  [MODALS.UPLOAD_TO_TARGET]: UploadToTargetModal,
  [MODALS.TAGS_EDITOR]: TagsEditorModal,
  [MODALS.PREVIEW_IMAGE]: PreviewImageModal,
  // Lazy-loaded to avoid circular dependency with SVG editor bundle.
  [MODALS.SVG_EDITOR]: () => import("./SVGEditorModal.vue"),
  [MODALS.FILE_INFO]: FileInfoModal,
  [MODALS.UPLOAD_PRODUCT_FILES]: UploadProductFilesModal,
  [MODALS.FOLDER_SETTINGS]: FolderSettingsModal,
  [MODALS.MERGE_PPTX]: MergePptxModal,
  [MODALS.IMPORT_FROM_IMAGE]: ImportFromImage,
  [MODALS.IMPORT_SPREADSHEET]: ImportSpreadsheetModal,
  [MODALS.PUBLISH_TO_PLATFORM]: PublishToPlatformModal,
  [MODALS.SHARE_PROOF]: ShareProofModal,
  [MODALS.SHARE_PROOF_VIDEO]: ShareProofVideoModal,
}

export default {
  name: "AllModals",
  computed: {
    ...mapGetters(['modal']),
    MODALS_COMPONENTS_MAP() {
      return MODALS_COMPONENTS_MAP
    }
  },
  watch: {
    modal(modal, prev) {
      if (!modal.type) {
        if (prev?.type) {
          this.close(prev.type, true)
        }
        return;
      }

      if (prev?.type && prev.type !== modal.type) {
        this.close(prev.type, true)
      }

      this.init(modal.type)
    }
  },
  methods: {
    ...mapMutations([MUTATIONS.SET_MODAL]),
    init(ref) {
      const _ref = isArray(this.$refs[ref]) ? this.$refs[ref][0] : this.$refs[ref];
      if (!_ref) {
        throw new Error(`There is no modal with ref ${ref}`)
      }

      _ref.init()
    },
    close(ref, silent = false) {
      const _ref = isArray(this.$refs[ref]) ? this.$refs[ref][0] : this.$refs[ref];
      if (_ref) {
        _ref.close(silent)
      }
    },
    freeModal() {
      this[MUTATIONS.SET_MODAL](createModal())
    }
  }
}
</script>

<style scoped lang="scss">

</style>
